@if (vm$ | async; as vm) {
  <ng-container *hardwareForm="(updateFormValue$ | async) ?? {}; let formGroup = form">
    <!--div
    class="flex flex-col mx-4 border-b border-b-secondary border-solid"
    [class.py-4]="!isOnlyView"
    >
    <span class="soft-overline opacity-70">Id: {{ vm?.syncedHardware?.autoid }}</span>
    <h2 class="font-semibold text-xl">
      {{
      vm.syncedHardware?.produkt?.produkt ||
      vm.syncedHardware?.produkt?.bezeichnung ||
      vm.syncedHardware?.hostname
      }}
    </h2>
    <span class="text-base opacity-70">{{
      vm?.syncedHardware?.hersteller?.hersteller ||
      vm?.syncedHardware?.hersteller?.bezeichnung
    }}</span>
  </div-->
  <div
    class="flex flex-col w-full mt-0 soft-card rounded transition-all ease-in-out mb-3 pb-2"
    >
    <div
      class="flex gap-4 items-center justify-between py-2 pr-2 pl-3"
      [ngClass]="vm.formOpened ? 'border-b-secondary border-b border-solid' : ''"
      >
      <div
        class="flex items-center gap-4"
        (click)="formOpened$.next(!formOpened$.value)"
        >
        <i
          class="fa-regular"
          [ngClass]="vm.formOpened ? 'fa-chevron-up' : 'fa-chevron-down'"
        ></i>
        <strong class="text-lg">{{
          '#HARDWARE_MANAGEMENT.PAGES.RESULTS.DETAIL_DATA' | translate
        }}</strong>
      </div>
      @if (vm.hasEditingPermission) {
        @if (!vm.editing) {
          <button
            class="soft-button soft-button-outline scale-90"
            (click)="editing$.next(true)"
            >
            <i class="fa-regular fa-pen-to-square"></i>
            {{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.EDIT' | translate }}
          </button>
        } @else {
          <div class="flex items-center gap-2 flex-shrink-0">
            <button
              class="soft-button soft-button-outline scale-90"
              (click)="cancelEditing(formGroup)"
              >
              {{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.CANCEL' | translate }}
            </button>
            <button
              class="soft-button primary scale-90"
              (click)="saveEditing(formGroup)"
              [disabled]="formGroup.invalid"
              >
              {{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.SAVE' | translate }}
            </button>
          </div>
        }
      }
    </div>
    @if (vm.formOpened) {
      <div class="p-4">
        <form [formGroup]="formGroup" class="w-full flex flex-col gap-4 py-2">
          <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
            <div class="w-full">
              <label class="soft-label soft-label-top w-full">{{
                '#HARDWARE_MANAGEMENT.FORM.HOSTNAME.LABEL' | translate
              }}</label>
              <soft-input
                class="mt-0.5"
                formControlName="hostname"
                [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.HOSTNAME.PLACEHOLDER' | translate
                }}"
              ></soft-input>
            </div>
            <div class="w-full">
              <label class="soft-label soft-label-top w-full">{{
                '#HARDWARE_MANAGEMENT.FORM.BENUTZER.LABEL' | translate
              }}</label>
              <soft-input
                class="mt-0.5"
                formControlName="benutzer"
                [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.BENUTZER.PLACEHOLDER' | translate
                }}"
              ></soft-input>
            </div>
            <lib-typ-input [readonly]="!vm.editing"></lib-typ-input>
            <lib-hersteller-input [readonly]="!vm.editing"></lib-hersteller-input>
            <lib-produkt-input [readonly]="!vm.editing"></lib-produkt-input>
            <div>
              <label class="soft-label soft-label-top w-full mb-0.5">{{
                '#HARDWARE_MANAGEMENT.FORM.SERIENNUMMER.LABEL' | translate
              }}</label>
              <soft-input
                class="mt-0.5"
                formControlName="seriennummer"
                [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.SERIENNUMMER.PLACEHOLDER' | translate
                }}"
              ></soft-input>
            </div>
            <soft-ktostamm-standort-input
              [readonly]="!vm.editing"
            ></soft-ktostamm-standort-input>
            <div class="w-full">
              <label class="soft-label soft-label-top w-full mb-0.5">{{
                '#HARDWARE_MANAGEMENT.FORM.STANDORT.LABEL' | translate
              }}</label>
              <soft-input
                class="mt-0.5"
                formControlName="standort"
                [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.STANDORT.PLACEHOLDER' | translate
                }}"
              ></soft-input>
            </div>
            <!--<div class="w-full">
            <label class="soft-label soft-label-top w-full">{{ '#HARDWARE_MANAGEMENT.FORM.SOFTLINEID.LABEL' | translate }}</label>
            <soft-input class="mt-0.5" formControlName="autoid" [readonly]="true" placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.SOFTLINEID.PLACEHOLDER' | translate }}"></soft-input>
          </div>-->
        </div>
        <!-- -->
        <div class="flex w-full">
          <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3 mt-6 w-full">
            <div class="w-full lg:col-start-1 lg:col-end-3">
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
                <ng-container *ngTemplateOutlet="formSection"></ng-container>
              </div>
            </div>
            <div class="xl:col-start-3 xl:col-end-3">
              <div class="w-full flex xl:mt-[1.375rem]">
                <div class="flex justify-between items-center w-full py-0.5">
                  <label class="soft-label soft-label-top w-full">{{
                    '#HARDWARE_MANAGEMENT.FORM.IP_STATISCH.LABEL' | translate
                  }}</label>
                  <soft-toggle-switch
                    formControlName="ip_statisch"
                    [readonly]="!vm.editing"
                    [disabled]="!vm.editing"
                    trueValue="J"
                    falseValue="N"
                  ></soft-toggle-switch>
                </div>
              </div>
              <div class="flex justify-between items-center w-full py-0.5">
                <label class="soft-label soft-label-top w-full">{{
                  '#HARDWARE_MANAGEMENT.FORM.IP_DHCP.LABEL' | translate
                }}</label>
                <soft-toggle-switch
                  formControlName="ip_dhcp"
                  [readonly]="!vm.editing"
                  [disabled]="!vm.editing"
                  trueValue="J"
                  falseValue="N"
                ></soft-toggle-switch>
              </div>
              <div class="flex justify-between items-center w-full py-0.5">
                <label class="soft-label soft-label-top w-full">{{
                  '#HARDWARE_MANAGEMENT.FORM.IP_DHCP_RESERVIERUNG.LABEL' | translate
                }}</label>
                <soft-toggle-switch
                  formControlName="ip_dhcp_reservierung"
                  [readonly]="!vm.editing"
                  [disabled]="!vm.editing"
                  trueValue="J"
                  falseValue="N"
                ></soft-toggle-switch>
              </div>
              <!-- <div class="flex justify-between items-center w-full py-0.5">
              <label class="soft-label soft-label-top w-full">SOFTLINE-ID</label>
              <soft-toggle-switch formControlName="ip_statisch" trueValue="J" falseValue="N"></soft-toggle-switch>
            </div> -->
          </div>
        </div>
        <ng-template #formSection>
          <div class="w-full">
            <label class="soft-label soft-label-top w-full">{{
              '#HARDWARE_MANAGEMENT.FORM.DOMAIN.LABEL' | translate
            }}</label>
            <soft-input
              class="mt-0.5"
              formControlName="domaene"
              [readonly]="!vm.editing"
                  placeholder="{{
                    '#HARDWARE_MANAGEMENT.FORM.DOMAIN.PLACEHOLDER' | translate
                  }}"
            ></soft-input>
          </div>
          <div>
            <label class="soft-label soft-label-top w-full mb-0.5">{{
              '#HARDWARE_MANAGEMENT.FORM.ARBEITSGRUPPE.LABEL' | translate
            }}</label>
            <soft-input
              class="mt-0.5"
              formControlName="arbeitsgruppe"
              [readonly]="!vm.editing"
                  placeholder="{{
                    '#HARDWARE_MANAGEMENT.FORM.ARBEITSGRUPPE.PLACEHOLDER' | translate
                  }}"
            ></soft-input>
          </div>
          <div class="w-full">
            <label class="soft-label soft-label-top w-full mb-0.5">{{
              '#HARDWARE_MANAGEMENT.FORM.MAC_ADRESSE.LABEL' | translate
            }}</label>
            <soft-input
              class="mt-0.5"
              formControlName="mac_adresse"
              [readonly]="!vm.editing"
                  placeholder="{{
                    '#HARDWARE_MANAGEMENT.FORM.MAC_ADRESSE.PLACEHOLDER' | translate
                  }}"
            ></soft-input>
          </div>
          <div class="w-full">
            <label class="soft-label soft-label-top w-full">{{
              '#HARDWARE_MANAGEMENT.FORM.IP_ADRESSE.LABEL' | translate
            }}</label>
            <soft-input
              class="mt-0.5"
              formControlName="ip_adresse"
              [readonly]="!vm.editing"
                  placeholder="{{
                    '#HARDWARE_MANAGEMENT.FORM.IP_ADRESSE.PLACEHOLDER' | translate
                  }}"
            ></soft-input>
          </div>
          <lib-subnetzmaske-input [readonly]="!vm.editing"></lib-subnetzmaske-input>
          <div class="w-full">
            <label class="soft-label soft-label-top w-full">{{
              '#HARDWARE_MANAGEMENT.FORM.GATEWAY.LABEL' | translate
            }}</label>
            <soft-input
              class="mt-0.5"
              formControlName="gateway"
              [readonly]="!vm.editing"
                  placeholder="{{
                    '#HARDWARE_MANAGEMENT.FORM.GATEWAY.PLACEHOLDER' | translate
                  }}"
            ></soft-input>
          </div>
          <div class="w-full">
            <label class="soft-label soft-label-top w-full mb-0.5">{{
              '#HARDWARE_MANAGEMENT.FORM.DNS1.LABEL' | translate
            }}</label>
            <soft-input
              class="mt-0.5"
              formControlName="dns1"
              [readonly]="!vm.editing"
                  placeholder="{{
                    '#HARDWARE_MANAGEMENT.FORM.DNS1.PLACEHOLDER' | translate
                  }}"
            ></soft-input>
          </div>
          <div class="w-full">
            <label class="soft-label soft-label-top w-full">{{
              '#HARDWARE_MANAGEMENT.FORM.DNS2.LABEL' | translate
            }}</label>
            <soft-input
              class="mt-0.5"
              formControlName="dns2"
              [readonly]="!vm.editing"
                  placeholder="{{
                    '#HARDWARE_MANAGEMENT.FORM.DNS2.PLACEHOLDER' | translate
                  }}"
            ></soft-input>
          </div>
        </ng-template>
      </div>
      <!-- -->
      <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3 mt-6">
        <lib-betriebssystem-input [readonly]="!vm.editing"></lib-betriebssystem-input>
        <div class="w-full">
          <label class="soft-label soft-label-top w-full mb-0.5">{{
            '#HARDWARE_MANAGEMENT.FORM.LIZENZKEY.LABEL' | translate
          }}</label>
          <soft-input
            class="mt-0.5"
            formControlName="lizenzkey"
            [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.LIZENZKEY.PLACEHOLDER' | translate
                }}"
          ></soft-input>
        </div>
        <div class="w-full">
          <label class="soft-label soft-label-top w-full mb-0.5">{{
            '#HARDWARE_MANAGEMENT.FORM.TEAMVIEWER_ID.LABEL' | translate
          }}</label>
          <soft-input
            class="mt-0.5"
            formControlName="teamviewerid"
            [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.TEAMVIEWER_ID.PLACEHOLDER' | translate
                }}"
          ></soft-input>
        </div>
        <div class="w-full">
          <label class="soft-label soft-label-top w-full mb-0.5">{{
            '#HARDWARE_MANAGEMENT.FORM.TEAMVIEWER_PW.LABEL' | translate
          }}</label>
          <soft-input
            class="mt-0.5"
            formControlName="teamviewer_passwort"
            [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.TEAMVIEWER_PW.PLACEHOLDER' | translate
                }}"
          ></soft-input>
        </div>
        <div class="w-full">
          <label class="soft-label soft-label-top w-full mb-0.5">{{
            '#HARDWARE_MANAGEMENT.FORM.LIEFERDATUM.LABEL' | translate
          }}</label>
          <soft-date-input
            class="mt-0.5"
            formControlName="lieferdatum"
            [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.LIEFERDATUM.PLACEHOLDER' | translate
                }}"
          ></soft-date-input>
        </div>
        <div class="w-full">
          <label class="soft-label soft-label-top w-full mb-0.5">{{
            '#HARDWARE_MANAGEMENT.FORM.AUSSCHEIDEDATUM.LABEL' | translate
          }}</label>
          <soft-date-input
            class="mt-0.5"
            formControlName="ausscheidedatum"
            [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.AUSSCHEIDEDATUM.PLACEHOLDER' | translate
                }}"
          ></soft-date-input>
        </div>
        <lib-garantietyp-input
          class="w-full"
          [readonly]="!vm.editing"
        ></lib-garantietyp-input>
        <lib-supporttyp-input
          class="w-full"
          [readonly]="!vm.editing"
        ></lib-supporttyp-input>
        <div class="w-full">
          <label class="soft-label soft-label-top w-full mb-0.5">{{
            '#HARDWARE_MANAGEMENT.FORM.SERVICE_TAG.LABEL' | translate
          }}</label>
          <soft-input
            class="mt-0.5"
            formControlName="service_tag"
            [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.SERVICE_TAG.PLACEHOLDER' | translate
                }}"
          ></soft-input>
        </div>
        <div class="w-full">
          <label class="soft-label soft-label-top w-full mb-0.5">{{
            '#HARDWARE_MANAGEMENT.FORM.EXPRESS_SERVICE_TAG.LABEL' | translate
          }}</label>
          <soft-input
            class="mt-0.5"
            formControlName="express_service_tag"
            [readonly]="!vm.editing"
                placeholder="{{
                  '#HARDWARE_MANAGEMENT.FORM.EXPRESS_SERVICE_TAG.PLACEHOLDER' | translate
                }}"
          ></soft-input>
        </div>
      </div>
    </form>
  </div>
}
</div>
<div
  class="flex flex-col w-full soft-card rounded transition-all ease-in-out mb-0 pb-2"
  >
  <div
    class="flex gap-4 items-center justify-between py-2 pr-2 pl-3"
    [ngClass]="vm.formOpened ? 'border-b-secondary border-b border-solid' : ''"
    >
    <div class="flex items-center gap-4">
      <strong class="text-lg">{{
        '#HARDWARE_MANAGEMENT.PAGES.RESULTS.DETAIL_COMMENTS' | translate
      }}</strong>
    </div>
    @if (vm.hasEditingPermission) {
      <button
        class="soft-button soft-button-outline scale-90"
        (click)="showCreateCommentDialog(vm.syncedHardware)"
        >
        <i class="fa-regular fa-pen-to-square"></i>
        {{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.CREATE' | translate }}
      </button>
    }
  </div>
  @if ((vm.comments?.length || 0) < 1) {
    <div
      class="p-2 min-h-[4rem] flex items-center justify-center text-center text-base opacity-70"
      >
      {{ '#HARDWARE_MANAGEMENT.PAGES.RESULTS.DETAIL_NO_COMMENTS' | translate }}
    </div>
  }
  @for (comment of vm.comments; track trackByEntityFn($index, comment); let last = $last) {
    <div
      class="p-2 flex flex-col gap-2"
      [ngClass]="!last ? 'border-b border-solid border-b-secondary-300' : ''"
      >
      <div class="flex items-center justify-between w-full mt-2">
        <div class="flex flex-col">
          <strong class="text-sm">
            {{ comment?.kontaktbw?.vorname }} {{ comment?.kontaktbw?.nachname }}
          </strong>
          <span class="text-sm opacity-50">{{ $safeNavigationMigration(comment?.zeit) | date }}</span>
        </div>
        <div class="flex gap-2">
          <i
            class="fa-regular fa-pen-to-square cursor-pointer p-2 hover:bg-gray-100 rounded"
            (click)="showEditCommentDialog(comment, vm.syncedHardware)"
          ></i>
          <i
            class="fa-regular fa-trash cursor-pointer p-2 hover:bg-gray-100 rounded text-danger"
            (click)="removeComment(comment, vm.syncedHardware)"
          ></i>
        </div>
      </div>
      <p class="text-sm -mt-1 p-0">{{ comment?.kommentar || '' }}</p>
    </div>
  }
</div>
</ng-container>
}
